import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'
import { StatusContainer, ClassificationContainer } from '../styles'

const HypertensionAndDyslipidemiaStatus = ({
  hypertensionAndDyslipidemiaData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {
  const {
    controlledHypertension,
    dyslipidemia,
    hypertension
  } = hypertensionAndDyslipidemiaData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="dyslipidemic"
          status={status}
          onSelect={onChange}
          value={dyslipidemia}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="hypertensive"
          status={status}
          onSelect={onChange}
          value={hypertension}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="controlledHypertension"
          status={status}
          onSelect={onChange}
          value={controlledHypertension}
          maxValue={beneficiaryWithCollectionCount}
        />
      </ClassificationContainer>

    </StatusContainer>
  )
}

HypertensionAndDyslipidemiaStatus.propTypes = {
  loading: PropTypes.bool,
  hypertensionAndDyslipidemiaData: PropTypes.shape({
    controlledHypertension: PropTypes.number,
    dyslipidemia: PropTypes.number,
    hypertension: PropTypes.number,
  }),
  status: PropTypes.shape({
    controlledHypertension: PropTypes.bool,
    dyslipidemia: PropTypes.bool,
    hypertension: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number
}

HypertensionAndDyslipidemiaStatus.defaultProps = {
  loading: false,
  hypertensionAndDyslipidemiaData: null,
  beneficiaryWithCollectionCount: 0,
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  hypertensionAndDyslipidemiaData: overview.hypertensionAndDyslipidemiaData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount
})

export default connect(mapStateToProps, null)(HypertensionAndDyslipidemiaStatus)
